module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_7_m2.08cf55565854787d283ff572986848a7.png";